var intervalTimeform = 500;
var maxIntervalTimeform = 15000;
var totalTimeform = 0;
$("#app-embed").addClass("loaded1390");

var intervalform = setInterval(function () {
  totalTimeform += intervalTimeform;

  var shadowRootform = document.querySelector("#app-embed").shadowRoot;

  if (shadowRootform) {
    var allChangesMadeForm = true;

    const labelsform = shadowRootform.querySelectorAll("label");

    labelsform.forEach(function (label) {
      if (label.style.textAlign !== "right" || label.style.width !== "100%") {
        label.style.textAlign = "right";
        label.style.width = "100%";
        // label.style.borderRadius = '24px';
        allChangesMadeForm = false; 
      }
    });

   const Sectionform = shadowRootform.querySelectorAll("section:first-child");
Sectionform.forEach(function (section) {
  if (section.style.maxWidth !== '100%') {
    section.style.maxWidth = '100%';
    allChangesMadeForm = false; 
  }
});
   
    const email_input = shadowRootform.querySelector('#phone_number');
    if (email_input) {
      email_input.style.textAlign = 'right';
      email_input.style.direction = 'rtl';
      allChangesMadeForm = false; 
    }

    
    if (allChangesMadeForm || totalTimeform >= maxIntervalTimeform) {
      clearInterval(intervalform);
    }
  }


  if (totalTimeform >= maxIntervalTimeform) {
    clearInterval(intervalform);
  }
}, intervalTimeform);









window.addEventListener("load", function() {
  // Check if the shadow root exists
  let shadowRootformSelect = document.querySelector("#app-embed")?.shadowRoot;
  
  if (!shadowRootformSelect) {
    console.log("Shadow DOM not found");
    return;
  }

  // Log for debugging
  console.log("Entered Shadow DOM");

  // Find the select toggle inside the shadow root
  const selectToggle = shadowRootformSelect.querySelector("._selectToggle_1yit2_25");

  if (!selectToggle) {
    console.log("Select Toggle not found in the Shadow DOM");
    return;
  }

  console.log("Select Toggle Found");

  // Check if the element is clickable (ensure it's not hidden or disabled)
  if (selectToggle.disabled || window.getComputedStyle(selectToggle).display === 'none') {
    console.log("Select Toggle is not clickable.");
    return;
  }

  // Use MutationObserver to watch for changes in the aria-expanded attribute
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      // Check if the mutation is related to aria-expanded change
      if (mutation.attributeName === "aria-expanded" && selectToggle.getAttribute("aria-expanded") === "true") {
        console.log("Select Toggle has been expanded!");

        // Apply the style to the option list items inside the shadow root
        const optionItems = shadowRootformSelect.querySelectorAll("._optionListItem_1yit2_99 > div");
        
        if (optionItems.length > 0) {
          optionItems.forEach(function(item) {
            item.style.textAlign = "right";
          });
          alert("Style applied to options!");
        } else {
          console.log("No options found.");
        }
      }
    });
  });

  // Observe changes to the aria-expanded attribute
  observer.observe(selectToggle, {
    attributes: true // Watch for changes to attributes like aria-expanded
  });

  console.log("MutationObserver is now watching for aria-expanded changes.");

  // Click the button to toggle aria-expanded
  selectToggle.addEventListener("click", function() {
    console.log("Select Toggle button clicked!");

    // If the select toggle is clicked, the aria-expanded attribute will change
    // The MutationObserver will pick up that change and apply styles
  });
});









